export default "__VITE_ASSET__4c3cee03__"